import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import QRCode from "react-qr-code";
import {getKCISData,getData,downloadExcelReports} from '../../services/index';
import { BellOutlined, QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined,UploadOutlined,MobileOutlined,FilterOutlined,WhatsAppOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";

import { Drawer,Popconfirm } from 'antd';

import DatePickers from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
 import axios from 'axios';

import $ from 'jquery';
const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

const { RangePicker } = DatePicker;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			total_leads: 0,
			field_staff: 0,
			total_campaign: 0,
			today_leads: 0,
			move_leads: 0,
			enroll_leads: 0,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id'],user_type:storedArray['data'][0]['type'] });
			
			var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
			var app = {user_id : storedArray['data'][0]['user_id'],school_id:storedArray['data'][0]['school_id']}
			getData('auth/get_login_token',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						var aToken= result['data'];
						localStorage.setItem("aToken",aToken);
						var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
						this.setState({
							kcis_link: kcis_link,
							aToken:aToken
						});
					}
					else{
						var aToken='null';
						localStorage.setItem("aToken",aToken);
						var kcis_link = 'https://erp.kidzonia.co.in/panel/admin';
						this.setState({
							kcis_link: kcis_link,
							aToken:aToken
						});
					}
				}
			});
			
			
			var school_id = storedArray['data'][0]['school_id'];
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],permission : permission,user_type : user_type});
		}
		this.checkData();
	}

	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {user_id : user_id,school_id:school_id}
			getKCISData('Leads/dashboard_data',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					this.setState({
						total_leads: result['total_leads'],
						field_staff: result['field_staff'],
						total_campaign: result['total_campaign'],
						today_leads: result['today_leads'],
						move_leads: result['move_leads'],
						enroll_leads: result['enroll_leads'],
					});
				}else{
					this.setState({
						source_type_list: [],
					});
				}
			});
		}
	}
  
	

  
	
   
  
   
 
   
   
	
	
   

	render() {
	const {aToken}=this.state;

		return (
				<>
				
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card">
							<div class="card-body">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Leads Dashboard
									
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Leads </li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>

				
				<div class="row">
					<div class="card-body">
						<ul class="nav nav-tabs nav-tabs-solid">
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/dashboard`} class="nav-link active">Dashboard</Link></li>
							<li class="nav-item"><a href={`${this.state.kcis_link}/campaign?t=${aToken}&s=${this.state.erp_id}`} class="nav-link" >Manage Campaign</a></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/list`} class="nav-link ">Leads</Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/today`} class="nav-link ">Today Followup </Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/missed`} class="nav-link ">Missed Followup </Link></li>
							<li class="nav-item"><Link to={`${process.env.PUBLIC_URL}/leads/move`} class="nav-link ">Move Leads </Link></li>
							<li class="nav-item"><a href={`${this.state.kcis_link}/field-staff?t=${aToken}&s=${this.state.erp_id}`} class="nav-link" >Manage Field Staff </a></li>
						</ul>
					</div>
				</div>
				
			   
			  
			   
			    <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 form-group">
					
						
						
						
						{/*  <div class="dashboard-container"> */}
						<div class="mt-3">
						  <div class="row">
						  
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.field_staff}</span>
								  <h4 class="dashboard-sub-heading mt-0">Field Staff</h4>
								</div>
							</div>
							
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.total_campaign}</span>
								  <h4 class="dashboard-sub-heading mt-0">Total Campaign</h4>
								</div>
							</div>
						  
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.today_leads}</span>
								  <h4 class="dashboard-sub-heading mt-0">Today Followup</h4>
								</div>
							</div>
						  
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.total_leads}</span>
								  <h4 class="dashboard-sub-heading mt-0">Total Lead</h4>
								</div>
							</div>
						  
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.move_leads}</span>
								  <h4 class="dashboard-sub-heading mt-0">Move Leads</h4>
								</div>
							</div>
						  
							<div class="col-md-2 center">
								<div class="dashboard-card dashboard-border">
								  <span class="dashboard-count">{this.state.enroll_leads}</span>
								  <h4 class="dashboard-sub-heading mt-0">Enroll Leads</h4>
								</div>
							</div>
							
						  </div>
						</div>
		
		
                        </div>
                        </div>
						
				
					
               </div>
			
			
			</>
		) 
	} 
}
export default Index;
